import { Enum } from 'api-base-refrence';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';

import { AuthenticationRoute } from '../../authentication.route';

export namespace ClientNotificationModel {
  export interface Full {
    id: number;
    title: string;
    content: string;
    type: string;
    created_at: string;
    isRead?: boolean;
    pageRoute?: string;
  }

  export type Add = Full;

  export type Edit = Full;

  export type Index = Full;

  export type Read = Pick<Full, 'id'> & {
    user: { id: number };
  };

  export class notifType extends Enum {
    static readonly 'info' = 'infoClass isax icon-info-circle  primary_6';
    static readonly 'error' = 'dangerClass isax icon-close-circle  danger_6';
    static readonly 'warn' = 'errorClass isax icon-warning-2 alarm_6';
    static readonly 'success' = 'successClass isax icon-tick-circle  success_6';
  }

  export class notifRoutes extends Enum {
    static readonly 'userWelcome' = AuthenticationRoute.map.dashboard.edit_user;
    static readonly 'loginSuccess' =
      SiteManagmentRoute.map.logs.dashboard.login_history;
    static readonly 'loginFailed' =
      SiteManagmentRoute.map.logs.dashboard.login_history;
    static readonly 'unreadNotifications' =
      AuthenticationRoute.map.dashboard.notifications;
  }
}
